import * as venmoAutomaticFriending from './venmoAutomaticFriending'
import {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  isAccountDataGathered,
} from './venmoGatherMachine'
import * as venmoNotifications from './venmoNotifications'
import * as venmoPaymentPrivacy from './venmoPaymentPrivacy'
import { VenmoRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [VenmoRecommendationKey.VENMO_PAYMENT_PRIVACY]: venmoPaymentPrivacy,
  [VenmoRecommendationKey.VENMO_AUTOMATIC_FRIENDING]: venmoAutomaticFriending,
  [VenmoRecommendationKey.VENMO_FRIENDS_LIST]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        VenmoRecommendationKey.VENMO_FRIENDS_LIST,
      ),
    ],
  },
  [VenmoRecommendationKey.VENMO_REMEMBERED_DEVICES]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        VenmoRecommendationKey.VENMO_REMEMBERED_DEVICES,
      ),
    ],
  },
  [VenmoRecommendationKey.VENMO_NOTIFICATIONS]: venmoNotifications,
}

export const venmoRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => getAccountUsernameGatherStageDefs(),
  getAdditionalFullGatherStageDefs: () => getAdditionalFullGatherStageDefs(),
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
